module.exports = __webpack_public_path__ + "static/img/lb_t.b48dd77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lb_t.png
// module id = kt0z
// module chunks = 1